import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Components
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import UserList from './components/UserList';
import AddUser from './components/AddUser';
import DrBill from './components/DrBill';
import UserProfile from './components/UserProfile';
import ChatAnalyticsPage from './components/ChatAnalyticsPage';
import ChatHistoryDetailPage from './components/ChatHistoryDetailPage';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <NotificationProvider>
          <Router>
            <CssBaseline />
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="users" element={<UserList />} />
                <Route path="users/add" element={<AddUser />} />
                <Route path="drbill" element={<DrBill />} />
                <Route path="profile" element={<UserProfile />} />
                <Route path="chat-analytics" element={<ChatAnalyticsPage />} />
                <Route path="chats/:chatId" element={<ChatHistoryDetailPage />} />
              </Route>
            </Routes>
          </Router>
        </NotificationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;